import navigation from './navigations'
import steps from './steps'

export default {
  navigation,
  steps,
}
